import React from "react";
import {MainCP}  from "../../Components/imagen-positiva/MainCP"

const ViewImagenPositiva: React.FC = () => <MainCP/>

export default ViewImagenPositiva;